import React from 'react';
import { Segment } from 'tea-component';
import classnames from 'classnames';
import { useIntl } from 'umi';

export default function TimeType(props: any) {
  const { onConfirm, value = '', lightTheme = true, className, optionsList } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  // console.log('props',props);

  const DEFAULTOPTIONS = [
    { text: formatMessage({ id: 'dbi_month' }), value: 'month' },
    { text: formatMessage({ id: 'dbi_week' }), value: 'week' },
    { text: formatMessage({ id: 'dbi_day' }), value: 'day' },
  ];

  const handleChange = (values: string[] | string) => {
    if (onConfirm instanceof Function) {
      onConfirm(values);
    }
  };

  return (
    <Segment
      className={classnames(
        {
          'segment-light': lightTheme,
        },
        className,
      )}
      value={value.toString()}
      onChange={handleChange}
      options={optionsList || DEFAULTOPTIONS}
    />
  );
}
